import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// 全局样式导入 — 从 anime/style.css 迁移而来
import './assets/css/global.css'

createApp(App).use(router).mount('#app')
